import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-stock-trans-allocations',
  templateUrl: './stock-trans-allocations.component.html',
  styleUrls: ['./stock-trans-allocations.component.css']
})
export class StockTransAllocationsComponent implements OnInit {
    argType;

    argValue;

    public setting?: Setting;

    public itemsListAllocations: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadSetting() {
        if (!!this.argType && !!this.argValue) {
            this.setting = (await this.datatask.Post(1868, {
                argtype: this.argType,
                argvalue: this.argValue
            }))[0];
        }
    }

    private async loadAllocations() {
        if (!this.setting) return;

        return this.itemsListAllocations = await this.datatask.Post(1870, this.setting);
    }

    private async init() {
        await this.loadSetting();
        this.loadAllocations();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    page_heading: string;
    argtype: string;
    argvalue: string;
}
